import script from "./PCBuildOrderListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PCBuildOrderListView.vue?vue&type=script&setup=true&lang=js"

import "./PCBuildOrderListView.vue?vue&type=style&index=0&id=20b50720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b50720"]])

export default __exports__